import request from './request'

/** 获取登录密码加密用的 RSA 公钥（无需 token） */
export function getPublicKey() {
  return request({ url: '/auth/public-key', method: 'get' })
}

/** 获取图形验证码（无需 token），返回 { captchaKey, imageBase64 } */
export function getCaptcha() {
  return request({ url: '/auth/captcha', method: 'get' })
}

export function login(data) {
  return request({ url: '/auth/login', method: 'post', data })
}

export function logout() {
  return request({ url: '/auth/logout', method: 'post' })
}

export function getInfo() {
  return request({ url: '/auth/info', method: 'get' })
}

/** 修改密码（需登录），body: { oldPassword, newPassword } 均为 RSA 加密后的字符串 */
export function changePassword(data) {
  return request({ url: '/auth/change-password', method: 'post', data })
}
